import { createSlice,   } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { outstandingReceivable } = stateEnum 

const initialState = {  
  currentParty: {
    id: "",
    name: "",
    remaningDaysRange: "",
  },
  isFromDashboard:false,
 
} 

const outstandingReceivableSlice = createSlice({
  name: outstandingReceivable,
  initialState,
  reducers: { 

    setCurrentParty: (state, action) => {
      state.currentParty.name = action.payload.party
      state.currentParty.id = action.payload.party_id
    },
    setCurrentPartyDaysRange: (state, action) => {
      state.currentParty.remaningDaysRange = action.payload.daysRange
    },
     setIsFromDashboardReceivable: (state, action) => {
      state.isFromDashboard=action.payload;
    },
    
  }, 
})

export const { 
  setCurrentParty,
  setCurrentPartyDaysRange,
  setIsFromDashboardReceivable
} = outstandingReceivableSlice.actions

export default outstandingReceivableSlice.reducer
